import {
  Box,
  CircularProgress,
  Divider,
  Paper,
  Typography,
} from '@mui/material';
import { useSelector } from 'react-redux';
import { selectAvailabilityDetailReportData } from '../../../store/ReportsDetailsSlice/selectors';
import { Fragment, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import {
  clearAvailabilityDetail,
  getAvailabilityDetailReportData,
} from '../../../store/ReportsDetailsSlice/actions';
import ReusableGrid from '../../../components/Grid';
import useAvailabilityDetailReportColumns from './hooks/useAvailabilityDetailReportColumns';
import useAvailabilityDetailReportRows from './hooks/useAvailabilityDetailReportRows';
import DataNotFound from '../../../components/Reports/DataNotFound';
import ReportsHeader from '../../../components/Reports/ReportsHeader';

const AvailabilityDetailReport = () => {
  const dispatch = useDispatch();
  const { availabilityDetail, isLoadingAvailabilityDetail } = useSelector(
    selectAvailabilityDetailReportData
  );

  useEffect(
    () => {
      dispatch(getAvailabilityDetailReportData());
      return () => dispatch(clearAvailabilityDetail());
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const columns = useAvailabilityDetailReportColumns();
  const rows = useAvailabilityDetailReportRows(availabilityDetail.data);

  return (
    <Paper className="p-4" sx={{ marginTop: '1rem' }}>
      <ReportsHeader title="Availability Detail Report" />

      {isLoadingAvailabilityDetail ? (
        <Box
          sx={{ minHeight: '30px' }}
          className="w-10 h-10 d-flex justify-content-center align-items-center"
        >
          <CircularProgress size={32} />
        </Box>
      ) : (
        <>
          {!!rows.length ? (
            <Box mt={4} sx={{ maxWidth: '900px' }}>
              {rows.map((item) => (
                <Box key={item.name} mb={4}>
                  <Typography variant="h6" fontWeight={600} mb={2}>
                    {item.name}
                  </Typography>
                  {item.items.map((item) => (
                    <Box key={item.name} mb={4}>
                      {item.items.map((item) => (
                        <Box key={item.name} mb={2}>
                          <Typography
                            variant="subtitle1"
                            fontWeight={500}
                            mb={1}
                          >
                            {item.name}
                          </Typography>
                          <ReusableGrid
                            columns={columns}
                            rows={item.items}
                            footer={item.footer}
                          />
                        </Box>
                      ))}
                      <Typography variant="h6">
                        Total {item.name}:{' '}
                        {item.items.reduce(
                          (total, subItem) => total + subItem.items.length,
                          0
                        )}
                      </Typography>
                    </Box>
                    // <Box key={item.name} mb={4}>
                    //   <Typography variant="h6" fontWeight={500} mb={2}>
                    //     {item.name}
                    //   </Typography>
                    //   <ReusableGrid columns={columns} rows={item.items} />
                    // </Box>
                  ))}
                  <Divider
                    sx={{
                      borderColor: 'var(--bs-heading-color);',
                    }}
                  />
                </Box>
              ))}
            </Box>
          ) : (
            <DataNotFound />
          )}
        </>
      )}
    </Paper>
  );
};

export default AvailabilityDetailReport;
